import { HttpClient } from '../HttpClient';
/**
 * * Get Salary History Details
 */

export const GetSalaryHistoryDetails = async ({
  employeeID,
  ExcludePending,
}) => {
  try {
    const { data } = await HttpClient.get(
      `/api/employees/${employeeID}/SalaryHistory`,
      {
        params: {
          ExcludePending,
        },
      }
    );

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
